<template>
  <div class="antialiased">

    <Sidebar/>


    <div class="page">

      <Header @keyup="_search" hint="Ketik nama barang"/>

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  Laporan Posisi Stock
                </h2> <small v-html="nama_gudang"></small>
              </div>

              <!-- <div class="col-auto">
                <div class="text-muted text-h5 mt-2">Login Pada {{auth.logged_at}}</div>
              </div> -->

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0">

                    <!-- <div class="input-icon">
                      <span class="input-icon-addon"> <i class="fe fe-align-left"></i> </span>
                      <select class="form-control" v-model="paginate.perPage" @change="_get" :disabled="loading">
                        <option :value="num" v-for="(num, i) in [10,50,100,999]" :key="i" v-html="num == 999 ? 'Semua' : num"/>
                      </select>
                    </div> -->

                  </div>

                  <div class="col-auto">
                    <button class="btn btn-white" v-html="ic('filter')+' Filter'" @click="_filter"></button>
                    <button class="btn btn-primary ml-3" :disabled="data.length == 0"
                            v-html="ic('download')+' Export Pdf'" @click="_createPdf"></button>
                    <button class="btn btn-primary ml-3" :disabled="data.length == 0"
                            v-html="ic('download')+' Export Excel'" @click="_createExcel"></button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>

          <Nodata v-if="!loading && data.length == 0 && isFilter"/>
          <div class="alert alert-info" v-if="!isFilter && !loading && data.length == 0">
            <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data Posisi Stock
          </div>

          <div class="box" v-if="!loading && data.length > 0">
            <div class="card">
              <div class="table-responsive">
                <table class="table table-vcenter table-hover card-table table-striped table-no-break">

                  <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama Gudang</th>
                    <th>Kode Barang</th>
                    <th>Nama Barang</th>
                    <th>Saldo Awal (dus/pcs)</th>
                    <th>Pembelian (dus/pcs)</th>
                    <th>Pembelian Cancel (dus/pcs)</th>
                    <th>Penjualan (dus/pcs)</th>
                    <th>Penjualan Cancel (dus/pcs)</th>
                    <th>Retur Penjualan (dus/pcs)</th>
                    <th>Retur Penjualan Cancel (dus/pcs)</th>
                    <th>Mutasi Masuk (dus/pcs)</th>
                    <th>Mutasi Masuk Cancel (dus/pcs)</th>
                    <th>Mutasi Keluar (dus/pcs)</th>
                    <th>Mutasi Keluar Cancel (dus/pcs)</th>
                    <th>Adjustment (dus/pcs)</th>
                    <th>Adjustment Cancel (dus/pcs)</th>
                    <th>Convert To PCS (dus/pcs)</th>
                    <th>Saldo Akhir (dus/pcs)</th>
                    <th class="text-right">Harga</th>
                    <th class="text-right">Nilai Stock</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, i) in data" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.nama_gudang }}</td>
                    <td>{{ row.kode_barang }}</td>
                    <td>{{ row.nama_barang }}</td>
                    <td title="Saldo Awal">{{ ribuan(row.stock_awal_qty) }}/{{ ribuan(row.stock_awal_qty_pcs) }}</td>
                    <td title="Pembelian">{{ row.penerimaan_barang_qty }}/{{ row.penerimaan_barang_qty_pcs }}</td>
                    <td title="Pembelian Cancel">{{
                        row.penerimaan_barang_cancel_qty
                      }}/{{ row.penerimaan_barang_cancel_qty_pcs }}
                    </td>
                    <td title="Penjualan">{{ row.penjualan_qty }}/{{ row.penjualan_qty_pcs }}</td>
                    <td title="Penjualan Cancel">{{ row.penjualan_cancel_qty }}/{{ row.penjualan_cancel_qty_pcs }}</td>
                    <td title="Retur Penjualan">{{ row.retur_penjualan_qty }}/{{ row.retur_penjualan_qty_pcs }}</td>
                    <td title="Retur Penjualan Cancel">{{
                        row.retur_penjualan_cancel_qty
                      }}/{{ row.retur_penjualan_cancel_qty_pcs }}
                    </td>
                    <td title="Mutasi Masuk">{{ row.mutasi_barang_in_qty }}/{{ row.mutasi_barang_in_qty_pcs }}</td>
                    <td title="Mutasi Masuk Cancel">{{
                        row.mutasi_barang_in_cancel_qty
                      }}/{{ row.mutasi_barang_in_cancel_qty_pcs }}
                    </td>
                    <td title="Mutasi Keluar">{{ row.mutasi_barang_out_qty }}/{{ row.mutasi_barang_out_qty_pcs }}</td>
                    <td title="Mutasi Keluar Cancel">{{
                        row.mutasi_barang_out_cancel_qty
                      }}/{{ row.mutasi_barang_out_cancel_qty_pcs }}
                    </td>
                    <td title="Adjustment">{{ row.adjustment_qty }}/{{ row.adjustment_qty_pcs }}</td>
                    <td title="Adjustment Cancel">{{ row.adjustment_cancel_qty }}/{{
                        row.adjustment_cancel_qty_pcs
                      }}
                    </td>
                    <td title="Convert To PCS">{{ row.convert_to_pcs_qty }}/{{ row.convert_to_pcs_qty_pcs }}</td>
                    <td title="Saldo Akhir Sistem">
                      {{ ribuan(row.stock_akhir_qty) }}/{{ ribuan(row.stock_akhir_qty_pcs) }}
                    </td>
                    <td title="Harga" class="text-right">
                      {{ ribuan(row.harga) }}
                    </td>
                    <td title="Nilai Stock" class="text-right">
                      {{ ribuan(row.nilai_stock) }} 
                    </td>
                  </tr>
                  </tbody>

                  <!--                  <tfoot>-->
                  <!--                  <tr>-->
                  <!--                    <td colspan="3">Total</td>-->
                  <!--                    <td v-for="(n, i) in tFooter" :key="i" v-html="n"></td>-->
                  <!--                  </tr>-->
                  <!--                  </tfoot>-->

                </table>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <FormFilter
        :config.sync="filter.config"
        :initData="filter.data" :dismiss.sync="filter.dismiss"
        :isSubmit.sync="filter.isSubmit"
        @submit="filter.action"
    />

  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";

import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "LaporanPosisiStock",
  components: {FormFilter},

  data() {
    return {
      auth: {},

      filter: {
        config: {view: false, title: null},
        data: null, isSubmit: false,
        action: () => {
        }
      },

      loading: false, isFilter: false,
      data: [], dataOri: [],

      paginate: {
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fromPage: 0
      },

      dataFilter: {
        id_mitra: null,
        id_gudang: null,
        start_date: this.dateTime('ymd'),
        end_date: this.dateTime('ymd'),
        id_principal: [],
        id_barang: [],
        id_brand: [],
        zero_stock: 'include',
      },

      nama_gudang: null,

      tFooter: []

    };
  },

  mixins: [helper],

  methods: {

    _get() {
      this.loading = true
      let formData = {
        tanggal: this.dataFilter.end_date,
        id_gudang: this.dataFilter.id_gudang,
        id_principal: this.dataFilter.id_principal,
        id_barang: this.dataFilter.id_barang,
        id_brand: this.dataFilter.id_brand,
        id_mitra: this.dataFilter.id_mitra,
      }

      this.axios.get("posisi_stock_mitra/transactions", {
        params: formData
      }).then(res => {
        this.loading = false;
        if (res.data.length !== 0) {

          let data = res.data.data

          if (this.dataFilter.zero_stock == 'include') {
            this.data = this.dataOri = data
          } else if (this.dataFilter.zero_stock == 'exclude') {
            this.data = this.dataOri = data.filter( (item) => { return item.nilai_stock > 0} )
          }

          // hitung total data
          // this.tFooter = []
          //
          // let keys = ['stock_awal_qty', 'stock_awal_qty_pcs', 'penerimaan_barang_qty', 'penerimaan_barang_qty_pcs', 'mutasi_barang_in_qty', 'mutasi_barang_in_qty_pcs', 'adjustment_qty', 'adjustment_qty_pcs', 'penjualan_cancel_qty', 'penjualan_cancel_qty_pcs', 'penjualan_qty', 'penjualan_qty_pcs', 'mutasi_barang_out_qty', 'mutasi_barang_out_qty_pcs', 'retur_penjualan_qty', 'retur_penjualan_qty_pcs', 'stock_akhir_qty', 'stock_akhir_qty_pcs'],
          //     temp = [] // hasil perhitungan total taruh di temp
          //
          // for (let k = 0; k < keys.length; k++) {
          //   temp.push(0)
          //
          //   for (let i = 0; i < data.length; i++) {
          //     let _data = data[i]
          //     temp[k] += _data[keys[k]]
          //   }
          // }
          //
          // for (let i = 0; i < temp.length; i++) {
          //   if ([0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20].indexOf(i) > -1) {
          //     this.tFooter.push(this.ribuan(temp[i]) + '/' + this.ribuan(temp[i + 1]))
          //   } else {
          //     if ([1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21].indexOf(i) < 0) {
          //       let rp = []
          //       this.tFooter.push(rp.indexOf(i) > -1 ? 'Rp ' + this.ribuan(temp[i]) : this.ribuan(temp[i] + '|,2'))
          //     }
          //   }
          // }

        }
      }).catch(err => {
        this.loading = false
        this.onError(err)
      });
    },

    _filter() {
      this.filter.config = {view: true, title: 'Filter'}
      this.filter.action = (formData) => {
        for (const key in formData) {
          this.dataFilter[key] = formData[key]
        }

        this.nama_gudang = formData.nama_gudang

        this._get()
      }
    },

    _search(keyword) {
      let k = keyword.toString().toLowerCase();
      this.data = []

      for (let i = 0; i < this.dataOri.length; i++) {
        if (this.dataOri[i].nama_barang.toLowerCase().includes(k) || this.dataOri[i].kode_barang.toLowerCase().includes(k)) {
          this.data.push(this.dataOri[i])
        }
      }
    },

    _createPdf() {
      let doc = new jsPDF({orientation: 'landscape'}), user = JSON.parse(localStorage.user);
      let styles = {fillColor: [255, 255, 255], cellPadding: 0, lineColor: 0}

      // title
      doc.autoTable(this.pdfHeader(''))
      doc.setDrawColor(0, 0, 0);
      doc.line(10, 31, 287, 31);
      doc.setLineWidth(0.5);
      doc.line(10, 30, 287, 30);
      let header = [['Kode Barang', 'Nama Barang', 'Saldo Awal', 'Pembelian', 'Penjualan', 'Retur Penjualan', 'Mutasi Masuk', 'Mutasi Keluar', 'Konversi', 'Saldo Akhir', 'Harga', 'Nilai Stock'
            // , 'Harga', 'Nilai Stok'
          ]],
          temp = []

      this.data.forEach((o, i) => {
        temp.push(o.kode_barang)
        temp.push(o.nama_barang)
        temp.push(this.ribuan(o['stock_awal_qty']) + '/' + this.ribuan(o['stock_awal_qty_pcs']))
        temp.push(this.ribuan(o['penerimaan_barang_qty'] + o['penerimaan_barang_cancel_qty']) + '/' + this.ribuan(o['penerimaan_barang_qty_pcs'] - o['penerimaan_barang_cancel_qty_pcs']));
        temp.push(this.ribuan(o['penjualan_qty'] + o['penjualan_cancel_qty']) + '/' + this.ribuan(o['penjualan_qty_pcs'] + o['penjualan_cancel_qty_pcs']));
        temp.push(this.ribuan(o['retur_penjualan_qty'] + o['retur_penjualan_cancel_qty']) + '/' + this.ribuan(o['retur_penjualan_qty_pcs'] + o['retur_penjualan_cancel_qty_pcs']));
        temp.push(this.ribuan(o['mutasi_barang_in_qty'] + o['mutasi_barang_in_cancel_qty']) + '/' + this.ribuan(o['mutasi_barang_in_qty_pcs'] + o['mutasi_barang_in_cancel_qty_pcs']));
        temp.push(this.ribuan(o['mutasi_barang_out_qty'] + o['mutasi_barang_out_cancel_qty']) + '/' + this.ribuan(o['mutasi_barang_out_qty_pcs'] + o['mutasi_barang_out_cancel_qty_pcs']));
        temp.push(this.ribuan(o['convert_to_pcs_qty']) + '/' + this.ribuan(o['convert_to_pcs_qty_pcs']));
        temp.push(this.ribuan(o['stock_akhir_qty']) + '/' + this.ribuan(o['stock_akhir_qty_pcs']));
        temp.push(this.ribuan(o['harga']));
        temp.push(this.ribuan(o['nilai_stock']));
        // temp.push(this.ribuan(o['harga']));
        // temp.push(this.ribuan(o['nilai_stock']));

        header.push(temp)
        temp = []
      });

      styles['cellPadding'] = 2;

      doc.autoTable({ // body
        theme: 'grid', styles: styles, margin: {top: 10, left: 10, right: 10},
        bodyStyles: {
          valign: "top",
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 9,
          lineWidth: .1,
          lineColor: 1
        },
        body: header
      })

      this.pdfDownload([doc.output()])
    },

    _createExcel() {
      let dataExcel = []
      for (let i = 0; i < this.data.length; i++) {
        let d = this.data[i]
        dataExcel.push({
          'id_gudang': d.id_gudang,
          'nama_gudang': d.nama_gudang,
          'tanggal': d.tanggal,
          'id_stock': d.id_stock,
          'kode_barang': d.kode_barang,
          'nama_barang': d.nama_barang,
          'nama_segmen': d.nama_segmen,
          'stock_awal_qty': d.stock_awal_qty,
          'stock_awal_qty_pcs': d.stock_awal_qty_pcs,
          'penerimaan_barang_qty': d.penerimaan_barang_qty,
          'penerimaan_barang_qty_pcs': d.penerimaan_barang_qty_pcs,
          'penerimaan_barang_cancel_qty': d.penerimaan_barang_cancel_qty,
          'penerimaan_barang_cancel_qty_pcs': d.penerimaan_barang_cancel_qty_pcs,
          'penjualan_qty': d.penjualan_qty,
          'penjualan_qty_pcs': d.penjualan_qty_pcs,
          'penjualan_cancel_qty': d.penjualan_cancel_qty,
          'penjualan_cancel_qty_pcs': d.penjualan_cancel_qty_pcs,
          'retur_penjualan_qty': d.retur_penjualan_qty,
          'retur_penjualan_qty_pcs': d.retur_penjualan_qty_pcs,
          'retur_penjualan_cancel_qty': d.retur_penjualan_cancel_qty,
          'retur_penjualan_cancel_qty_pcs': d.retur_penjualan_cancel_qty_pcs,
          'mutasi_barang_in_qty': d.mutasi_barang_in_qty,
          'mutasi_barang_in_qty_pcs': d.mutasi_barang_in_qty_pcs,
          'mutasi_barang_in_cancel_qty': d.mutasi_barang_in_cancel_qty,
          'mutasi_barang_in_cancel_qty_pcs': d.mutasi_barang_in_cancel_qty_pcs,
          'mutasi_barang_out_qty': d.mutasi_barang_out_qty,
          'mutasi_barang_out_qty_pcs': d.mutasi_barang_out_qty_pcs,
          'mutasi_barang_out_cancel_qty': d.mutasi_barang_out_cancel_qty,
          'mutasi_barang_out_cancel_qty_pcs': d.mutasi_barang_out_cancel_qty_pcs,
          'adjustment_qty': d.adjustment_qty,
          'adjustment_qty_pcs': d.adjustment_qty_pcs,
          'adjustment_cancel_qty': d.adjustment_cancel_qty,
          'adjustment_cancel_qty_pcs': d.adjustment_cancel_qty_pcs,
          'convert_to_pcs_qty': d.convert_to_pcs_qty,
          'convert_to_pcs_qty_pcs': d.convert_to_pcs_qty_pcs,
          'stock_akhir_qty': d.stock_akhir_qty,
          'stock_akhir_qty_pcs': d.stock_akhir_qty_pcs,
          'harga': d.harga,
          'nilai_stock': d.nilai_stock,
          'nama_brand': d.nama_brand,
          'volume': d.isi,
        })
      }
      this.createExcel({data: dataExcel, filename: 'laporan-stock-mitra-' + this.dataFilter.end_date})
    }

  },

  mounted() {
    this.auth = JSON.parse(localStorage.user)
  },

};
</script>
